import React from "react";
import styled from "styled-components";
import { Field } from "redux-form";
import { IonItem, IonLabel } from "@ionic/react";

const SelectFieldContainer = styled.div`
  padding: 8px;
`;
const SelectFieldLabel = styled(IonLabel)`
  width: fit-content !important;
  margin: 0px 0px 8px 8px;
`;

const FormField = (props) => {
  let content = (
    <IonItem>
      <IonLabel position="floating">{props.label}</IonLabel>
      <Field {...props} />
    </IonItem>
  );

  if (props.formFieldType === "select") {
    content = (
      <SelectFieldContainer>
        <SelectFieldLabel position="fixed">{props.label}</SelectFieldLabel>
        <Field {...props} />
      </SelectFieldContainer>
    );
  }

  return content;
};

export default FormField;
